import { ReactNode } from "react";

/**
 * Props for a single label/value row in the Summary tab.
 */
interface SummaryFieldRowProps {
  /** Bold left-side label (colon included by the caller when needed). */
  label: string;
  /** Right-side value; may be text or a custom node (e.g. decision badge). */
  children: ReactNode;
  /** When true, hides the bottom dotted divider. */
  isLast?: boolean;
}

/**
 * Label/value row with a dotted bottom divider matching the Evaluation Engine design.
 *
 * @param props.label - Field label shown in bold
 * @param props.children - Field value content
 * @param props.isLast - Whether this is the last row (no divider)
 */
const SummaryFieldRow = (props: SummaryFieldRowProps) => {
  return (
    <div
      className={`flex gap-6 p-4 ${
        props.isLast ? "" : "border-b border-dashed border-primaryGray-14 items-center"
      }`}
    >
      <div className="w-[9.5rem] shrink-0 text-small font-bold leading-5 text-primaryGray-1">
        {props.label}
      </div>
      <div className="min-w-0 flex-1 text-small font-normal leading-5 text-primaryGray-2">
        {props.children}
      </div>
    </div>
  );
};

export default SummaryFieldRow;
